import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { SERVER_URL, BUILD_PLATFORM, PLATFORM_PWA, PLATFORM_ANDROID, PLATFORM_IOS } from '../constants';
import { appointmentStatusToString, appointmentStatusAvatarStyle, appointmentStatusToIcon } from '../helpers/Helpers';
import { Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ListItemIcon from "@mui/material/ListItemIcon";
import CustomerListOptions from './CustomerListOptions';
// import { downloadCsv, downloadCsvAndroid } from '../helpers/Helpers';
import { downloadCsv } from '../helpers/Helpers';
import QuickModal from './QuickModal';
import AppointmentStatusAvatar from './AppointmentStatusAvatar';
import EditCustomerName from './EditCustomerName';
import dayjs from 'dayjs';
import VerticalHamburgerMenu from './VerticalHamburgerMenu';
import { formatMinutes } from '../helpers/Helpers';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
}));
  
  
function CustomerList (props) {

    const today = dayjs();

    const [open, setOpen] = React.useState(false);

    const [message, setMessaage] = useState("fetching data...");

    const handleClickOpen = () => {
        setOpen(true);
        fetchCustomerAppointments();
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
    };   

    const [customerAppointments, setCustomerAppointments] = useState([]);

    const enrichAppointmentsWithEta = (appointments, startTime, averageServeMinutes) => {
        const baseTime = dayjs().hour(Number(startTime.split(":")[0]))
                          .minute(Number(startTime.split(":")[1]))
                          .second(Number(startTime.split(":")[2]));

        return appointments.map((appt) => {
            if (appt.status !== 1) return appt;

            const earlierActiveCount = appointments.filter(
            (other) =>
                [1, 3, 4].includes(other.status)
                && other.customer_number < appt.customer_number
            ).length;

            const eta = baseTime.add(earlierActiveCount * averageServeMinutes, "minute");

            return {
            ...appt,
            eta: eta.format("h:mm A") // e.g., "6:10 PM"
            };
        });
    };

    const [csvData, setCsvData] = useState([]);

    const convertDataForCsv = (jsonData) => {
        var array = [];
        var header = {number: 'Number', name: 'Name', status: 'Status', minutes: 'Minutes'};
        array.push(header);
        for (var item of jsonData) 
        {
            var object = {};
            object.number = item.customer_number;
            object.name = item.name;
            object.status = appointmentStatusToString(item.status);
            object.minutes = item.minutes && item.minutes != null ? item.minutes : "";
            array.push(object);
        }
        setCsvData(array);
    }

    const handleDownloadCsv = (params) => {
        var csvFilename = props.officeName + " Clients List " + props.rawDate;
        if (BUILD_PLATFORM === PLATFORM_PWA)
        {
            downloadCsv({data: params.data, fileName: csvFilename});
        }
        // if (BUILD_PLATFORM === PLATFORM_ANDROID)
        // {
        //     downloadCsvAndroid({data: csvData, fileName: csvFilename});
        //     setQuickModalMessage( "CSV file downloaded to your Documents folder: [" + csvFilename + ".csv]");
        //     setQuickModalOpen(true);
        // }
    }

    const [quickModalOpen, setQuickModalOpen] = useState(false);

    const [quickModalMessage, setQuickModalMessage] = useState("");
    
    const fetchCustomerAppointments = () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/list-customer-appointments/' + props.scheduleId, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            //console.log("data.data", data.data);
            const enriched = enrichAppointmentsWithEta(data.data, props.startTime, props.averageServeMinutes);
            setCustomerAppointments(enriched);
            convertDataForCsv(enriched);
            if (enriched < 1) setMessaage("No confirmed appointments");
        })
        .catch(err => console.error(err));
    };

    const [addCustomerModalOpen, setAddCustomerModalOpen] = useState(false);

    const handleAddCustomer = () => {
        setAddCustomerModalOpen(true);
    }

    const [verticalMenuOptions, setVerticalMenuOptions] = useState([
        {
            id: 1,
            name: "Export List",
            callback: handleDownloadCsv
        },
        ...(!dayjs(props.rawDate).isBefore(today, 'day')
            ? 
            [
                {
                    id: 3,
                    name: "Add Client/Customer",
                    callback: handleAddCustomer
                },
            ]
        : []),
    ]);

    return(
        <React.Fragment>
            <QuickModal 
                quickModalOpen={quickModalOpen}
                quickModalMessage={quickModalMessage}
                setQuickModalOpen={setQuickModalOpen} 
            />
            {props.hideButton ? 
                null :
                <IconButton
                        onClick={handleClickOpen}
                        size="medium"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                    >
                    <PeopleAltIcon fontSize='large' sx={{ color: 'gray' }} />
                </IconButton>
            }
            
            <BootstrapDialog
            sx={{
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "500px",  // Set your width here
                  },
                },
            }}
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                <Stack
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                spacing={0}
                >
                    <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                    Appointments<br />{props.date} 
                    </Typography>
                    <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                    {props.officeName}<br />
                    {"Service Velocity: " + props.averageServeMinutes + " mins"}
                    </Typography>
                </Stack>
            </DialogTitle>
            
            <DialogContent sx={{ m: 0, p: 0 }} dividers>
                
                <List>
                    {customerAppointments.map(customerAppointment => (
                        <ListItem key={customerAppointment.id} selected={customerAppointment.status == 3 ? true : false}>
                            <AppointmentStatusAvatar rawDate={props.rawDate} fetchCustomerAppointments={fetchCustomerAppointments} fetchOffices={props.fetchOffices} customerAppointment={customerAppointment} customerAppointments={customerAppointments}/>
                            <ListItemText
                                primary={customerAppointment.name}
                                secondary={
                                    <Typography variant="body2" color="textSecondary" style={{ whiteSpace: 'pre-line' }}>
                                    {typeof customerAppointment.minutes === "number"
                                        ? `${appointmentStatusToString(customerAppointment.status)} | ${formatMinutes(customerAppointment.minutes)}`
                                        : `${appointmentStatusToString(customerAppointment.status)}`}
                                    </Typography>
                                }
                            />
                            <ListItemIcon>
                                <CustomerListOptions minutes={customerAppointment.minutes} status={customerAppointment.status} date={props.rawDate} officeId={props.officeId} appointmentId={customerAppointment.id} customerId={customerAppointment.user_id} customerName={customerAppointment.name} />
                            </ListItemIcon>
                        </ListItem>
                    ))} 
                    {customerAppointments.length < 1 ? <Typography  sx={{ ml: 2, flex: 1 }} variant="body2" component="div">{ message }</Typography> : null}
                </List>
                </DialogContent>
                <DialogActions>
                    <VerticalHamburgerMenu 
                        options={verticalMenuOptions} 
                        params={{
                            data: csvData
                        }}
                    />
                    {/* <Button onClick={handleDownloadCsv}>
                        Export List
                    </Button> */}
                    {props.date === 'TODAY' ? <EditCustomerName hideButton={false} setAddCustomerModalOpen={setAddCustomerModalOpen} open={addCustomerModalOpen} officeId={props.officeId} rawDate={props.rawDate} fetchCustomerAppointments={fetchCustomerAppointments} fetchOffices={props.fetchOffices} /> : null }
                    <div style={{flex: '1 0 0'}} />
                    <Button autoFocus onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default CustomerList;